import { Col, Container, Row, Form } from "react-bootstrap";
import { useSafariPackagesContext } from "provider/SharePackagesProvider";
import parse from 'html-react-parser';

const Inclusions = () => {
    const { packageViewData } = useSafariPackagesContext();
    const packageInclusions = packageViewData?.master_package_with_included || [];
    const mealsLabel = packageViewData?.mealslabel || "";

    const packageDetails = {
        package_inclusion: packageViewData?.package_inclusion || "",
        package_exclusion: packageViewData?.package_exclusion || "",
    };

    return (

        <div className="card bg-set accordion-collapse card_bodyPadding">
            <div className="card-body p-3">
                <Container>
                    <Row>
                        <Col md={12}>
                            <div className="form-group">


                                {packageInclusions?.map((item) => (
                                    <Row key={item.id} className="mb-2">
                                        <Col md={3} sm={4}>
                                            <ul className="mb-0 px-3">
                                                <li>
                                                    <label className="control-label font_sizes">
                                                        {item.title}
                                                    </label>
                                                </li>
                                            </ul>
                                        </Col>
                                        <Col md={9} sm={8}>
                                            <Form.Label className="d-flex align-items-center">
                                                {item.option}
                                            </Form.Label>
                                        </Col>
                                    </Row>
                                ))}

                                {mealsLabel && (
                                    <Row className="mb-2">
                                        <Col md={3} sm={4}>
                                            <ul className="mb-0 px-3">
                                                <li>
                                                    <label className="control-label font_sizes">Meals</label>
                                                </li>
                                            </ul>
                                        </Col>
                                        <Col md={9} sm={8}>
                                            <Form.Label className="d-flex gap-3">{mealsLabel}</Form.Label>
                                        </Col>
                                    </Row>
                                )}
                            </div>
                        </Col>
                    </Row>

                    <Row className="inclusions">
                        <Col md={12} className="pt-3">
                            {packageDetails.package_inclusion && <div className="itenary-title">
                                <h6 className="fs-6 fw-bold mb-2">Inclusions </h6>
                            </div>
                            }
                            {packageDetails.package_inclusion && parse(packageDetails.package_inclusion)}
                            {packageDetails.package_exclusion && <div className="itenary-title">
                                <h6 className="fs-6 fw-bold mb-2">Exclusion </h6>
                            </div>
                            }
                            {packageDetails.package_exclusion && parse(packageDetails.package_exclusion)}
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default Inclusions;